import { Component, OnInit } from '@angular/core';
// import { CommonModule } from "@angular/common";
// import { OmniComponent } from '../omni/omni.component';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { environment } from 'src/environments/environment'; 

@Component({
  selector: 'app-report',
  // standalone: true,
  // imports: [CommonModule, OmniComponent],
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  dashboardId: string = environment.ID;
  quotedPriceId: any;

  constructor(private route: ActivatedRoute) {}
  ngOnInit(): void {
    this.dashboardId = this.route.snapshot.paramMap.get(
      "dashboardId"
    ) as string;
    this.route.queryParams
    .subscribe(params => {
      this.quotedPriceId=params;
    })
    this.route.params.subscribe((parameter: any) => {
      console.log(parameter)
      this.dashboardId = parameter.dashboardId;
    });
  }

}
// import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute } from '@angular/router';

// @Component({
//   selector: 'app-report',
//   templateUrl: './report.component.html',
//   styleUrls: ['./report.component.scss']
// })
// export class ReportComponent implements OnInit {
//   dashboardId: string = "abc";
//   // quotedPriceId!: string | null;
//   quotedPriceId: any;

//   constructor(private route: ActivatedRoute) {}

//   ngOnInit(): void {
//     this.route.params.subscribe((params: any) => {
//       this.dashboardId = params.dashboardId;
//     });

//     this.route.queryParams.subscribe(params => {
//       this.quotedPriceId = params['quotedPriceId'] || null;
//     });
//   }
// }
